module.exports = __webpack_public_path__ + "img/olohuone_thumbnail_x2.61be3cfd.jpg";